import { useEffect, useState } from "react";
import UsuarioOutput from "../../models/UsuarioOutput";
import http from "../../../../http";

export const useBuscaMeuUsuario = () => {
    const [dadosMeuUsuario, setDadosMeuUsuario] = useState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        setLoading(true)
        setError(null)
        http.get(`/meus-dados`)
        .then(res => {
            const meusDados = res.data
            const dadosMeuUsuario = UsuarioOutput.create(meusDados)
            setDadosMeuUsuario(dadosMeuUsuario)
        })
        .catch(error => {
            setDadosMeuUsuario(null)
            setError(error.response || error)
        })
        .finally(() => {
            setLoading(false)
        })
    }, [])

    return {
        dadosMeuUsuario,
        loading,
        error
    }
}
